import * as React from 'react';

import { EntityCard, type EntityProps } from '../EntityCard/EntityCard';
import { TagList } from '../TagList/TagList';
import { getOpensourceProjectTags } from '../../utils/opensourceProject';
import { getRepoFacts } from '../../utils/repo';
import { routes } from '../../config/routes';

interface Props extends EntityProps {
  withEntityType?: boolean;
  skills: CustomTypes.FilterTag[];
  services: CustomTypes.FilterTag[];
  product?: boolean;
  repoData: CustomTypes.RepoData;
  facts?: CustomTypes.Facts | null;
  productsPage?: boolean;
  externalLink?: boolean;
  linkMain?: string;
  logo?: {
    publicURL: string;
  };
  hideTags?: boolean;
}

export const OpensourceProjectCard = ({
  slug,
  withEntityType,
  services,
  skills,
  product,
  repoData,
  size,
  facts,
  productsPage,
  externalLink,
  linkMain,
  hideTags = false,
  ...restProps
}: Props) => {
  const projectFacts = [...(facts || []), ...getRepoFacts(repoData, 2, false)];

  let url = product ? routes.product(slug) : routes.opensourceProject(slug);

  if (externalLink) {
    url = linkMain || '';
  }

  const details = hideTags ? (
    <span />
  ) : (
    <TagList
      entries={getOpensourceProjectTags({
        skills,
        services,
        withEntityType,
        productsPage,
        product,
      })}
      mainVariant={withEntityType ? 'EntityType' : 'Service'}
    />
  );

  return (
    <EntityCard
      type="oss"
      slug={slug}
      url={url}
      externalLink={externalLink}
      details={details}
      facts={size === 'lg' ? projectFacts : []}
      size={size}
      {...restProps}
    />
  );
};
